import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ROUTES, SECTIONS } from "../../data/content";

//Scrolls to a section of the home page (/#about etc.). Works from other pages too, and when the #hash is already in the URL
export const scrollToSection = (section) => {
  if (section === SECTIONS.TOP) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.getElementById(section);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const SectionLink = ({ section, className, onClick, children, ...rest }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const href = section === SECTIONS.TOP ? ROUTES.HOME : `${ROUTES.HOME}#${section}`;

  const onLinkClick = (e) => {
    if (onClick) {
      onClick(e);
    }
    //Let ctrl/cmd-click open a new tab as normal
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    if (pathname === ROUTES.HOME) {
      window.history.replaceState(null, "", href);
      scrollToSection(section);
    }
    else {
      navigate(href);
    }
  };

  return (
    <a
      href={href}
      className={className}
      onClick={onLinkClick}
      {...rest}
    >
      {children}
    </a>
  );
};

export default SectionLink;
